module.exports = __webpack_public_path__ + "static/img/hehai.a7ec742.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/assets/image/hehai.png
// module id = z7Vm
// module chunks = 20